module.exports = __webpack_public_path__ + "static/media/1 37 interessant.fec1be06.mp3";